type PrefixFn = (raw: string) => string;
type UnprefixFn<TNone> = (prefixed: string) => string | TNone;

export function prefixer<TNone>(
  prefix: string,
  onFail?: (str: string) => TNone,
): [PrefixFn, UnprefixFn<TNone>] {
  return [
    (raw: string) => `${prefix}${raw}`,
    (prefixed: string) =>
      onFail && !prefixed.startsWith(prefix)
        ? onFail(prefixed)
        : prefixed.substring(prefix.length),
  ];
}
